import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-auth-redirect',
  standalone: true,
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthRedirectComponent {}
